var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadial2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1114,
    height: 252,
    viewBox: "0 0 1114 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_134_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.797 493.593C361.953 493.593 204.001 392.371 204.001 267.507C204.001 142.642 341.156 240.42 536 240.42C730.844 240.42 909.594 142.642 909.594 267.507C909.594 392.371 751.641 493.593 556.797 493.593Z",
    fill: "url(#paint0_linear_134_563)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_134_563",
    x: 0.000976562,
    y: 0,
    width: 1113.59,
    height: 697.593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 102,
    result: "effect1_foregroundBlur_134_563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_563",
    x1: 218.251,
    y1: 392.034,
    x2: 563.159,
    y2: 57.2147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#B8E7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#59C6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#B164EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4471"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadial2);
export default __webpack_public_path__ + "static/media/radial2.0ed2451d9c7b75751607d851b823657f.svg";
export { ForwardRef as ReactComponent };